import {inject} from 'aurelia-framework';  
import {Router} from 'aurelia-router';
import {AuthService} from '../../services/authService';
import {UserMessageService} from '../../services/userMessageService';
import { ContactAPI } from '../../services/contactAPI';
import $ from 'jquery';
import 'jquery-ui-dist';
@inject(AuthService, Router, ContactAPI, UserMessageService)
export class Contacts {
    constructor(authService, router, api, userMessageService) {
        
        this.authService = authService;
        this.router = router;
        this.api = api;
        this.userMessageService = userMessageService;
        
        this.saving = false;
        this.groups = [
            { id: 0, name: 'Group1' },
            { id: 1, name: 'Group2' },
            { id: 2, name: 'Group3' },
        ];
        this.selectedGroup = null;
        this.selectedGroupLabel = null;
        this.groupEditMode = false;
        
        this.contacts_top_menue = true;
        this.upload_section = false;
        this.add_group_section = false;
        
        this.selectedFiles = null;
        this.label = null;
        this.onlySelectedGroup = false;
        
        this.add_action = true;
        this.edit_action = false;
        this.del_action = false;
        this.only_group_action = false;
        this.data = [];
        
    }
     attached(){
    /*$('#tag').autocomplete({
      source: this.data
    });*/
        this.autocomplete(this.data);
        
  }
  autocomplete(data){
            
       $("#tag")
      // don't navigate away from the field on tab when selecting an item
      .on( "keydown", function( event ) {
        if ( event.keyCode === $.ui.keyCode.TAB &&
            $( this ).autocomplete( "instance" ).menu.active ) {
          event.preventDefault();
        }
      })
      .autocomplete({
          minLength: 0,
        /*source: this.data,*/
        source: function( request, response ) {
            response($.ui.autocomplete.filter(
                data, request.term.split(/,\s*/).pop() 
                ) 
            );
        },
        focus: function() {
          // prevent value inserted on focus
          return false;
        },
        search: function( event, ui ) {
        console.log('Search');    
        },
        select: function( event, ui ) {
          //var terms = this.split( this.value );
          var terms = this.value.split( /,\s*/ );
          // remove the current input
          terms.pop();
          // add the selected item
          terms.push( ui.item.value );
          // add placeholder to get the comma-and-space at the end
          terms.push( "" );
          this.value = terms.join( ", " );
          return false;
        }
      });
  }
    activate(params) {
        this.loading = true;
       

        this.load();
    }

    load() {
         
        this.api.getList(
            this.authService.getUser().token,
            {},
            this.saveLoadSuccess.bind(this), 
            this.saveLoadError.bind(this));
        this.api.getGroupList(
            this.authService.getUser().token, 
            this.saveLoadSuccessG.bind(this), 
            this.saveLoadErrorG.bind(this)
        );
        this.get_contacts_groups();
        
    }
    get_contacts_groups(){
        this.data = [
          {id:1, label:'Japan1', value:'Japan1'},
          {id:2, label:'USA1', value:'USA1'},
          {id:3, label:'Canada1', value:'Canada1'},
          {id:4, label:'Pakistan1', value:'Pakistan1'}
        ];
    }
  
    save() {
        if (this.validate()) 
        {
            this.saving = true;
            this.api.save(
                this.contacts, 
                this.authService.getUser().token, 
                this.saveLoadSuccess.bind(this), 
                this.saveLoadError.bind(this));
        }
    }

    saveLoadSuccess(data) {
        this.loading = false;
        this.contacts = data;
       
        if(this.saving)
            this.userMessageService.setUserMessage("user", "Saved!");
        this.saving = false;
    }

    saveLoadError(msg) {
        this.userMessageService.setUserError("user", msg);
        this.loading = false;
        
    }

    itemChanged(item) {
        item.changed = true;

       
    }

    deleteItem(item, index) {
        if(item.new) {
            this.contacts.splice(index, 1);
        } else {
            if(confirm("Delete contact " + item.first_name + "?")) {
                this.saving = true;
                this.api.delete(
                    item, 
                    this.authService.getUser().token, 
                    this.saveLoadSuccess.bind(this), 
                    this.saveLoadError.bind(this));
            }
        }
    }
    add_remove_contacts(item, index){
        console.log(item);
        console.log(index);
        this.contacts[index].group_id = this.selectedGroup.id;
        /*
        email: "B1@m.com"
    ​    first_name: "aa"
        group_id: true
        id: 14
        last_name: "aa"
        user_id: 14893 
        */
    }
    
    addContact() {
        this.contacts.push({
          "first_name": "",
          "last_name": "",
          "email": "",
          "new": true
        });
    }
    addGroup(){
        //this.router.navigate("#/capture/brand/" + this.captureKey + "?method=fileupload&uploadonly=1");
        this.router.navigate("#/user/groups");
        //this.contacts_top_menue = false;
        //this.upload_section = false;
        if(0){
        this.add_group_section = true;
        this.selectedGroupLabel = "";
        
        this.add_action = true;
        this.edit_action = false;
        this.del_action = false;
        }
    }
    editGroup(){
        this.add_group_section = true;
        this.groupEditMode = true;
        this.selectedGroupLabel = this.selectedGroup.label;
    }
    importContacts(){
        //this.router.navigate("#/capture/brand/" + this.captureKey + "?method=fileupload&uploadonly=1");
        this.contacts_top_menue = false;
        this.upload_section = true;
        //this.add_group_section = false;
    }
    uploadCsv(){
        
    }
    cancelCsv(){
        this.contacts_top_menue = true;
        this.upload_section = false;
        //this.add_group_section = false;
    }
    saveGroup(){
        var data = {
            'label': this.selectedGroupLabel,
            'id': (this.groupEditMode) ? this.selectedGroup.id : null
        };
        this.api.saveGroup(
            data,
            this.authService.getUser().token, 
            this.saveLoadSuccessG.bind(this), 
            this.saveLoadErrorG.bind(this)
        );
    }
    deleteGroup(){
        if(!this.selectedGroup.id){
            alert('Please select a group to edit');
            return;
        }
        var res = confirm('Are you sure you want to delet this group?');
        if(res != true){
            console.log('Delete cancelled');
            return;
        }
        var data = {
            'id': this.selectedGroup.id
        };
        this.api.deleteGroup(
            data,
            this.authService.getUser().token, 
            this.saveLoadSuccessG.bind(this), 
            this.saveLoadErrorG.bind(this)
        );
    }
    cancelGroup(){
        //this.contacts_top_menue = true;
        //this.upload_section = false;
        this.add_group_section = false;
        this.groupEditMode = false;
        if(!this.selectedGroup.id){
            this.add_action = true;
            this.edit_action = false;
            this.del_action = false;;
        } else{
            this.add_action = true;
            this.edit_action = true;
            this.del_action = true;
            
        }
    }
    onlyGroupContacts(){
        this.onlySelectedGroup = !this.onlySelectedGroup;
        this.groupChanged();
    }
    groupChanged(){
        if(!this.selectedGroup.id){
            console.log('No Group Selected ');
            this.add_action = true;
            this.edit_action = false;
            this.del_action = false;
            this.only_group_action = false;
            this.add_group_section = false;
        } else {
            console.log('Group Selected ' + this.selectedGroup.id);
            this.add_action = true;
            this.edit_action = true;
            this.del_action = true;
            this.only_group_action = true;
            this.add_group_section = false;
            
            
        }
         var data = {
            'group_id': this.selectedGroup.id,
            'group_only': this.onlySelectedGroup
        };
        this.api.getList(
            this.authService.getUser().token,
            data,
            this.saveLoadSuccess.bind(this), 
            this.saveLoadError.bind(this));
    }
    saveLoadSuccessG(data) {
        //this.loading = false;
        console.log('Group Data');
        console.log(data);
        this.groups = data;
       
        /*if(this.saving)
            this.userMessageService.setUserMessage("user", "Saved!");
        this.saving = false;*/
    }

    saveLoadErrorG(msg) {
        this.userMessageService.setUserError("user", msg);
        //this.loading = false;
        
    }
    validate() 
    {
        var pass = true;

        var data = this.contacts;

        for(var i = 0; i < data.length; i++) {
            //console.log(data[i].first_name  + " <-----");
            if(data[i].first_name === null || data[i].first_name.trim() == '' ) {
                this.userMessageService.setUserError('user', 'First Name is empty');
                pass = false;
            }

            if (data[i].last_name === null || data[i].last_name.trim() === '') {
                this.userMessageService.setUserError('user', 'Last name is empty');
                pass = false;
            }

            if (data[i].email === null || data[i].email.trim() === '') {
                this.userMessageService.setUserError('user', 'Email is empty');
                pass = false;
            }
    
            if (!this.is_email(data[i].email)) {
                this.userMessageService.setUserError('user', 'Email is not a valid email address');
                pass = false;
            }
        }

        return pass;
    }

    is_email(email) {
        var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        return emailReg.test(email);
    }
    
}
